import Avatar from "@/components/bricks/avatar/Avatar";
import Button from "@/components/bricks/button/Button";
import AdminIcon from "../components/icons/AdminIcon";
import ArrowRightIcon from "../components/icons/ArrowRightIcon";
import ASLogo from "../components/icons/ASLogo";
import FirmaIcon from "../components/icons/FirmaIcon";
import KursusIcon from "../components/icons/KursusIcon";
import EfteruddannelseIcon from "../components/icons/EfteruddannelseIcon";
import PersonIcon from "../components/icons/PersonIcon";
import PageTitle from "@/components/PageTitle";
import { useContext } from "react";
import { UserQueryContext } from "../context/UserContext";
import { useLogout } from "../hooks/useLogout";

const Home = () => {
  return (
    <>
      <PageTitle title="Advokatsamfundet" />
      <meta name="theme-color" content="rgb(1, 30, 46)" />
      <Page />
    </>
  );
};

const Page = () => {
  const { user, hasPermission } = useContext(UserQueryContext);
  const logout = useLogout();

  return (
    <div className="l-front">
      <header className="p-4 d-flex">
        <div className="link-light">
          <ASLogo height={60} />
          <span className="sr-only">Advokatsamfundet</span>
        </div>
        <div className="ms-auto d-flex align-items-center gap-3">
          <Button
            outline
            size="sm"
            color="light"
            onClick={() => {
              void logout();
            }}
          >
            Log ud
          </Button>
          <Avatar color="light" size="lg" round>
            {user.initials}
          </Avatar>
        </div>
        {/* <h1 className="text-light">Aika</h1> */}
      </header>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-6 d-grid gap-4 entry-cards">
            <Button fullWidth outline size="lg" color="light" href={"/person"}>
              <>
                <span className="c-theme-icon c-theme-icon--person">
                  <PersonIcon />
                </span>{" "}
                Personindeks <ArrowRightIcon width={24} />
              </>
            </Button>
            <Button fullWidth outline size="lg" color="light" href={"/firma"}>
              <>
                <span className="c-theme-icon c-theme-icon--firma">
                  {" "}
                  <FirmaIcon />
                </span>{" "}
                Firmaindeks <ArrowRightIcon width={24} />
              </>
            </Button>
            <Button
              fullWidth
              outline
              size="lg"
              color="light"
              href={"/kursus"}
              className={!hasPermission(user, "KursusRead") ? "disabled" : ""}
            >
              <>
                <span className="c-theme-icon c-theme-icon--kursus">
                  <KursusIcon />
                </span>{" "}
                Kursusindeks <ArrowRightIcon width={24} />
              </>
            </Button>
            <Button
              fullWidth
              outline
              size="lg"
              color="light"
              href={"/efteruddannelse"}
              className={!hasPermission(user, "TilsynRead") ? "disabled" : ""}
            >
              <>
                <span className="c-theme-icon c-theme-icon--efteruddannelse">
                  <EfteruddannelseIcon />
                </span>{" "}
                Efteruddannelse <ArrowRightIcon width={24} />
              </>
            </Button>
            <div className="mt-5 entry-card--sm">
              <Button
                fullWidth
                outline
                size="lg"
                color="light"
                href={"/admin"}
                className={!hasPermission(user, "AdminRead") ? "disabled" : ""}
              >
                <>
                  <span className="c-theme-icon">
                    <AdminIcon />
                  </span>{" "}
                  Administration <ArrowRightIcon width={24} />
                </>
              </Button>
            </div>
          </div>
        </div>
      </div>
      <footer className="p-10 text-center">
        &nbsp;
        {/* <a href="#" className="link-light">
    <ASLogo />
    <span className="sr-only">Advokatsamfundet</span></a> */}
      </footer>
    </div>
  );
};

export default Home;
